export enum ProgressState {
  STARTED = 0,
  IN_PROGRESS = 1,
  MATERIAL_REQUESTED = 2,
  COMPLETED = 3,
  COMPLETED_YELLOW = 4,
  COMPLETED_RED = 5,
  REJECTED = 6,
}
